import request from "@/utils/request";
import Qs from "qs";
// 共享办公

// 工位预约列表
export function stationReservationList(data) {
  return request({
    url: "/station/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 工位添加
export function stationReservationAdd(data) {
  return request({
    url: "/station/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 工位编辑
export function stationReservationEdit(data) {
  return request({
    url: "/station/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 工位详情
export function stationReservationInfo(data) {
  return request({
    url: "/station/info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 工位删除
export function stationReservationDel(data) {
  return request({
    url: "/station/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 房间工位预约登记
export function stationReservationRegister(data) {
  return request({
    url: "/station_make/register",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑工位预约登记
export function stationReservationEditRegister(data) {
  return request({
    url: "/station_make/edit_register",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 解除预约
export function stationReservationDelRegister(data) {
  return request({
    url: "/station_make/del_register",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 员工列表
export function stationReservationUserList(data) {
  return request({
    url: "/station/user_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加房间工位的用户
export function stationReservationUserAdd(data) {
  return request({
    url: "/station/user_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑房间工位的用户
export function stationReservationUserEdit(data) {
  return request({
    url: "/station/user_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 查看房间工位的用户
export function stationReservationUserInfo(data) {
  return request({
    url: "/station/user_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除房间工位的用户
export function stationReservationUserDel(data) {
  return request({
    url: "/station/user_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 工位预约登记列表
export function stationReservationListed(data) {
  return request({
    url: "/station_make/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 工位预约登记列表-记录详情列表
export function record_lists(data) {
  return request({
    url: "/station_make/record_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 工位预约登记列表导出
export function lists_export(data) {
  return request({
    url: "/station_make/lists_export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}
// 查看工位预约登记
export function stationReservationInfoRegister(data) {
  return request({
    url: "/station_make/info_register",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 工位租赁退款
export function stationReservationRefund(data) {
  return request({
    url: "/station_make/refund",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 洽谈室
// 洽谈室列表
export function reception_room_lists(data) {
  return request({
    url: "/place/reception_room_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加洽谈室
export function reception_room_add(data) {
  return request({
    url: "/place/reception_room_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑洽谈室
export function reception_room_edit(data) {
  return request({
    url: "/place/reception_room_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 洽谈室详情
export function reception_room_info(data) {
  return request({
    url: "/place/reception_room_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除洽谈室
export function reception_room_del(data) {
  return request({
    url: "/place/reception_room_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 洽谈室预约列表
export function reception_room_apply_lists(data) {
  return request({
    url: "/place/reception_room_apply_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 洽谈室预约列表导出
export function reception_room_apply_export(data) {
  return request({
    url: "/place/reception_room_apply_lists_export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}

// 洽谈室预约取消操作
export function reception_room_apply_operation(data) {
  return request({
    url: "/place/reception_room_apply_operation",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 洽谈室预约详情
export function reception_room_apply_info(data) {
  return request({
    url: "/place/reception_room_apply_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 政策扶持
// 政策扶持列表
export function policy_lists(data) {
  return request({
    url: "/policy/lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加政策扶持
export function policy_add(data) {
  return request({
    url: "/policy/add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑政策扶持
export function policy_edit(data) {
  return request({
    url: "/policy/edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 政策扶持详情
export function policy_info(data) {
  return request({
    url: "/policy/info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除政策扶持
export function policy_del(data) {
  return request({
    url: "/policy/del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 设置春风基金文章
export function set_fund(data) {
  return request({
    url: "/policy/set_banner",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 会议室预约
// 会议室列表
export function meeting_lists(data) {
  return request({
    url: "/place/huiyishi_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 会议室详情
export function meeting_info(data) {
  return request({
    url: "/place/huiyishi_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 添加会议室
export function meeting_add(data) {
  return request({
    url: "/place/huiyishi_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 编辑会议室
export function meeting_edit(data) {
  return request({
    url: "/place/huiyishi_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 删除会议室
export function meeting_del(data) {
  return request({
    url: "/place/huiyishi_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 会议室服务列表
export function meeting_service_list(data) {
  return request({
    url: "/place/service_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 会议室服务删除
export function meeting_service_del(data) {
  return request({
    url: "/place/service_del",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 会议室服务编辑
export function meeting_service_edit(data) {
  return request({
    url: "/place/service_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 会议室服务新增
export function meeting_service_add(data) {
  return request({
    url: "/place/service_add",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 会议室预约记录列表
export function meeting_apply_lists(data) {
  return request({
    url: "/place/huiyishi_apply_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 会议室预约列表导出
export function meeting_apply_export(data) {
  return request({
    url: "/place/huiyishi_apply_lists_export",
    method: "post",
    data: Qs.stringify(data),
    responseType: "blob",
  });
}
// 会议室预约详情
export function meeting_apply_info(data) {
  return request({
    url: "/place/huiyishi_apply_info",
    method: "post",
    data: Qs.stringify(data),
  });
}
// 会议室预约记录的操作（取消，通过
export function meeting_apply_operation(data) {
  return request({
    url: "/place/huiyishi_apply_operation",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 会议室取消预约
export function meeting_apply_refund(data) {
  return request({
    url: "/place/huiyishi_apply_refund",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 获取会议室和洽谈室的权限点
export function get_meeting_auth(data) {
  return request({
    url: "/common/get_meeting_auth",
    method: "post",
    data: Qs.stringify(data),
  });
}
